type StarPropsType = {
  type: "full" | "empty" | "half";
  className?: string;
  starColor?: string;
};

export const Star = ({ type, className = "", starColor }: StarPropsType) => (
  <div className={className}>
    {type === "full" && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M15.5754 5.71885L10.6567 4.96639L8.45208 0.263392C8.28741 -0.0877974 7.71208 -0.0877974 7.54741 0.263392L5.34342 4.96639L0.424765 5.71885C0.0207661 5.78094 -0.140567 6.27301 0.142766 6.56344L3.71609 10.2316L2.87143 15.4173C2.80409 15.8292 3.24342 16.1384 3.60676 15.9361L8.00008 13.5044L12.3934 15.9367C12.7534 16.137 13.1967 15.8339 13.1287 15.418L12.2841 10.2322L15.8574 6.56411C16.1407 6.27301 15.9787 5.78094 15.5754 5.71885Z"
          fill={starColor}
        />
      </svg>
    )}
    {type === "half" && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99935 7.72906e-09C7.81433 -3.00762e-05 7.62929 0.087762 7.54695 0.263376L5.34309 4.96609L0.424739 5.7185C0.0207648 5.78059 -0.140558 6.27262 0.142757 6.56304L3.71586 10.2309L2.87125 15.4163C2.80392 15.8283 3.24323 16.1374 3.60654 15.9351L7.99935 13.5038V7.72906e-09Z"
          fill={starColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99951 13.5037V0C8.18444 5.36061e-05 8.36934 0.0878456 8.45165 0.263376L10.6562 4.96609L15.5745 5.7185C15.9778 5.78059 16.1398 6.27262 15.8565 6.56371L12.2834 10.2316L13.128 15.417C13.196 15.8329 12.7527 16.136 12.3927 15.9358L7.99968 13.5036L7.99951 13.5037Z"
          fill="#F0F0F5"
        />
      </svg>
    )}
    {type === "empty" && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M15.5754 5.71885L10.6567 4.96639L8.45208 0.263392C8.28741 -0.0877974 7.71208 -0.0877974 7.54741 0.263392L5.34342 4.96639L0.424765 5.71885C0.0207661 5.78094 -0.140567 6.27301 0.142766 6.56344L3.71609 10.2316L2.87143 15.4173C2.80409 15.8292 3.24342 16.1384 3.60676 15.9361L8.00008 13.5044L12.3934 15.9367C12.7534 16.137 13.1967 15.8339 13.1287 15.418L12.2841 10.2322L15.8574 6.56411C16.1407 6.27301 15.9787 5.78094 15.5754 5.71885Z"
          fill="#F0F0F5"
        />
      </svg>
    )}
  </div>
);
